import budgetActions from "containers/Budget/_actions";
import { push } from "connected-react-router";
import farmActions from "containers/Farm/_actions";
import { syncDirtyBudgets } from "containers/Budget/_actions";
import ReactGA from "react-ga4";

export function submitCrop(budget, farmId) {
    ReactGA.event({
        category: "Crop",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: farmActions.FARM_FETCH_CANCEL });
        dispatch({ type: budgetActions.BUDGET_TOUCHED, payload: { budget } });
        dispatch(push(`/app/farm/${farmId}/analysis/${budget.id}/crops`));
        dispatch(syncDirtyBudgets(budget.id));
    };
}
